import React, { useEffect } from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';

import * as actions from './actions';
import ProjectForm from './components/ProjectForm';
import * as selectors from './selectors';

const Container = ({
    closeModal,
    contacts,
    fetchContacts,
    filterData,
    isFetchingContacts,
    isNewRecord,
    isOpenModal,
    reset,
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        fetchContacts();
    }, []);

    useEffect(() => {
        return () => reset();
    }, []);

    return (
        <Dialog
            onClose={() => closeModal()}
            onExited={() => closeModal()}
            open={isOpenModal}
            title={`${isNewRecord ? t('Create') : t('Update')} ${t(
                'Project',
            ).toLowerCase()}`}
            size="sm"
        >
            <ProjectForm
                contacts={contacts}
                filterData={filterData}
                isFetchingContacts={isFetchingContacts}
                isNewRecord={isNewRecord}
            />
        </Dialog>
    );
};

const mapStateToProps = createStructuredSelector({
    contacts: selectors.getContactsData,
    isFetchingContacts: selectors.getIsFetchingContacts,
    isNewRecord: selectors.getIsNewRecord,
    isOpenModal: selectors.getIsOpenModal,
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => dispatch(actions.closeModal()),
    fetchContacts: () => dispatch(actions.fetchContacts()),
    initializeValues: (values) => dispatch(actions.initializeValues(values)),
    reset: () => dispatch(actions.reset()),
});

Container.propTypes = {
    closeModal: PropTypes.func,
    contacts: PropTypes.array,
    fetchContacts: PropTypes.func,
    filterData: PropTypes.object,
    isFetchingContacts: PropTypes.bool,
    isNewRecord: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    reset: PropTypes.func,
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
)(Container);
